import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import omit from "lodash/omit";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
export const defaultCurrency = {
  icon: "UnitedStates",
  id: "USD",
  multiplier: 1,
  name: "USD",
  symbol: "$",
  zeroDecimal: false
};
export const useCurrencies = () => {
  const {
    data,
    mutate,
    error,
    isLoading
  } = useSWR(`/api/v4/currencies/rates`, fetcher);
  let currencies = [];
  if (data !== null && data !== void 0 && data.objects) {
    currencies = data.objects.map(currency => _objectSpread(_objectSpread({}, omit(currency, ["zero_decimal"])), {}, {
      zeroDecimal: currency.zero_decimal
    }));
  }
  return {
    currencies: currencies || [],
    error: error ? "There was an issue loading currencies. Please try again" : null,
    isLoading,
    onSelectCurrency: currency => {
      mutate(_objectSpread(_objectSpread({}, data), {}, {
        selectedCurrency: currency
      }), false);
    }
  };
};
//# sourceMappingURL=useCurrencies.js.map